import { PRIVACYPOLITICSMX, PRIVACYPOLITICSBACK} from 'constants/api'
import useAxios from 'axios-hooks'
import LoadingScreen from 'components/loading-screen'
import styled from 'styled-components'
import { Type } from 'theme/types'
import ErrorView from 'components/error-view'
import useRouter from 'hooks/use-router'
import stylespp from './stylepp.module.scss'

const Div = styled.div`
  ${({ theme }: Type) => theme?.termsAndConditions?.div}
`

const PrivacyPolitics = () => {
  const { push } = useRouter()

  const fetchURL = THEME_CONFIG.privacyPolitics !== 'MX' ? PRIVACYPOLITICSBACK : PRIVACYPOLITICSMX
  console.log(THEME_CONFIG.privacyPolitics)
  const [{ loading, error, data }] = useAxios({
    url: fetchURL
  })

  if (error) {
    return <ErrorView code={9999} buttonMenu={() => push('/home')} />
  }

  if (loading) {
    return <LoadingScreen />
  }

  if (data) {
    const body = data.replace("{","").replace('"body":"','').replace('";','').replace('}','');
    return <Div className={stylespp.wrapperpp}>
      <div dangerouslySetInnerHTML={{ __html: body }}></div>
    </Div>
  }
}

export default PrivacyPolitics
